import type { HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/shared/lib/utils';

/**
 * Etiqueta neutra: categoria, espaço, contagem.
 *
 * NÃO use para situação do projeto — situação tem componente próprio
 * (`StatusBadge`), com o vocabulário e o tom de cor fixados em
 * `constants/statuses.ts`. Duas formas de pintar a mesma coisa é como uma
 * delas fica para trás quando o vocabulário muda.
 */
const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium',
  {
    variants: {
      variant: {
        outline: 'border-border bg-transparent text-muted-foreground',
        muted: 'border-transparent bg-muted text-muted-foreground',
        primary: 'border-transparent bg-primary/10 text-primary',
      },
    },
    defaultVariants: { variant: 'outline' },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
